/* eslint-disable no-useless-concat */
const baseName = '/scape-report-admin';

module.exports = {
    scapeReportAdminHome: baseName,
    createScape:baseName +'/create',
    editScape:baseName +'/edit' + '/:id',
    
}